import SectionHeading from "./SectionHeading";
import { statsList, decadeBars } from "@/mocks/content";

export default function EraStats() {
  return (
    <section id="stats" className="scroll-mt-20 bg-background-50 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="By The Numbers"
          title="年代与题材分布一览"
          desc="用几个数字快速建立整体印象：本页收录的作品以九十年代为主，兼顾八十年代末的经典，题材则集中在几个高辨识度的方向。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {statsList.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-200 bg-background-100 p-5 text-center"
            >
              <p className="font-heading text-3xl md:text-4xl font-bold text-primary-600">
                {stat.value}
              </p>
              <p className="mt-2 text-sm font-medium text-foreground-900">{stat.label}</p>
              <p className="mt-1 text-xs text-foreground-500 leading-relaxed">
                {stat.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-8 md:mt-10 rounded-lg border border-background-200 bg-background-100 p-5 md:p-8">
          <h3 className="font-heading text-lg font-semibold text-foreground-950">
            各题材在片库中的相对比重
          </h3>
          <p className="mt-1 text-sm text-foreground-500">
            比重用于直观比较不同方向内容的多少，不代表作品数量统计。
          </p>
          <div className="mt-6 space-y-5">
            {decadeBars.map((bar) => (
              <div key={bar.label}>
                <div className="flex items-center justify-between gap-3 mb-1.5">
                  <span className="text-sm font-medium text-foreground-800">
                    {bar.label}
                  </span>
                  <span className="text-xs text-foreground-500 hidden sm:block">
                    {bar.note}
                  </span>
                </div>
                <div className="h-2.5 w-full rounded-full bg-background-200 overflow-hidden">
                  <div
                    className="h-full rounded-full bg-accent-500"
                    style={{ width: `${bar.percent}%` }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}